import axios from 'axios'
const instance = axios
  .create({
    // baseURL: 'http://localhost:5002/api/',
    baseURL: 'http://72.60.100.121:5000/api/',
    timeout: 10000,
    headers: { 'X-Custom-Header': 'foobar' }
  });

// Add a request interceptor
instance.interceptors.request.use(function (config) {
  // Do something before request is sent
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

// Add a response interceptor
instance.interceptors.response.use(function (response) {
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  return response?.data;
}, function (error) {
  console.log({ error })
  // Any status codes that falls outside the range of 2xx cause this function to trigger
  // Do something with response error
  return Promise.reject(error);
});


export { instance }